import { LegalLayout } from "@/components/LegalLayout";

export default function RefundPolicy() {
  const sections = [
    {
      heading: "Overview",
      body: "This Refund Policy explains the terms under which ILFAL (\"we\", \"us\") offers refunds for subscriptions and payments made on the Platform. By purchasing a subscription, you agree to this policy.",
    },
    {
      heading: "Subscriptions",
      body: "ILFAL is offered as a recurring subscription. Your subscription grants access to premium content for the billing period you select at checkout and renews automatically unless cancelled before the renewal date.",
    },
    {
      heading: "Cancellation",
      body: "You may cancel your subscription at any time from your account settings or billing portal. When you cancel, you retain access to paid features until the end of your current billing period, after which the subscription will not renew. Cancelling does not automatically trigger a refund for the current period.",
    },
    {
      heading: "Refund Eligibility",
      body: "Because our product provides immediate access to digital educational content, all sales are generally considered final. We may, at our discretion, provide a refund in the following circumstances:",
      list: [
        "You were charged in error or charged more than once for the same period.",
        "A technical issue on our side prevented you from accessing the service and could not be resolved within a reasonable time.",
        "You request a refund within 7 days of your initial purchase and have not substantially used the paid content.",
      ],
    },
    {
      heading: "Non-Refundable Situations",
      body: "Refunds will generally not be granted for:",
      list: [
        "Renewal charges where the subscription was not cancelled before the renewal date.",
        "Partial or unused portions of a billing period after the period has begun.",
        "Change of mind after substantial use of the paid content.",
        "Violations of our Terms of Service that result in account termination.",
      ],
    },
    {
      heading: "How to Request a Refund",
      body: "To request a refund, email support@ilfal.com from the address associated with your account, including your order details and the reason for the request. We aim to respond within 5 business days.",
    },
    {
      heading: "Processing of Refunds",
      body: "Approved refunds are issued to the original payment method through our payment provider. The time for the refund to appear depends on your bank or card issuer, typically within 5–10 business days.",
    },
    {
      heading: "Changes to This Policy",
      body: "We may update this Refund Policy from time to time. Changes will be posted here with a revised \"Last updated\" date and apply to purchases made after the change takes effect.",
    },
    {
      heading: "Contact",
      body: "For any questions about refunds or billing, contact us at support@ilfal.com.",
    },
  ];

  return (
    <LegalLayout
      testid="refund-policy-page"
      title="Refund Policy"
      updated="June 2026"
      intro="We want you to be satisfied with ILFAL. This policy outlines when and how refunds are handled for subscriptions and payments."
      sections={sections}
    />
  );
}
